export default __webpack_public_path__ + "static/favicon-97e4bbe24b5c551cc48c49fba6113bbc.png";